export enum EJHHAPIRequestKey {
    PUBLIC_KEY = "public_key",
    MOBILE = "mobile",
    MOBILE_NO = "mobile_no",
    OTP = "otp",
    OTP_ID = "otp_id",
    COUNTRY_CODE = "country_code",
}

export enum EJHHDeviceConstants {
    DEVICE_ID = "device_id",
    DEVICE_OS = "device_os",
    DEVICE_USER_ID = "device_user_id",
    DEVICE_JIO_ID = "device_jio_id",
    DEVICE_NAME = "device_name",
    DEVICE_MODEL = "device_model",
    UNIQUE_ID = "unique_id",
    SYNC_ID = "sync_id",
    LANG_NAME = "lang_name",
    DEVICE_TYPE = "device_type", //changing this will require change in plugandplay/components/authorise in the interface
    VERSION_NUMBER = "version_number", //changing this will require change in plugandplay/components/authorise in the interface
    DEVICE_AUTH_KEY = "device_auth_key",
}

export const CITY = "mumbai";
export const PINCODE = 470122;
export const GUEST_USER = "guest-usr";
